
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as _ref_QGpzLWpvZGEvY29yZQ_ from '@js-joda/core';
import * as _ref_YWJseQ_ from 'ably';
import * as _ref_Y3J5cHRvLWpz_ from 'crypto-js';
import { instantiate } from './GoogleDevToolsMobile-composeApp.uninstantiated.mjs';


const exports = (await instantiate({
    './skiko.mjs': Li9za2lrby5tanM,
    '@js-joda/core': _ref_QGpzLWpvZGEvY29yZQ_,
    'ably': _ref_YWJseQ_,
    'crypto-js': _ref_Y3J5cHRvLWpz_
})).exports;

export const {
memory,
_initialize
} = exports


